import styled from 'styled-components'

import { Button } from '@/ui/atoms/button'

export const VipLocationMapContainer = styled.div(
  ({ theme }) => `
  border-radius: ${theme.borderRadius.medium};
  display: flex;
  flex-direction: column;
  height: 13rem;
  margin-bottom: ${theme.spacing.large};
  overflow: hidden;
  position: relative;
  width: 100%;
`
)

export const VipLocationDirectionsButton = styled(Button)(
  ({ theme }) => `
  margin-left: ${theme.spacing.default};
  margin-top: ${theme.spacing.default};
  position: absolute;
`
)
